module.exports = __webpack_public_path__ + "static/media/quality-1.82a1d7d4.jpg";